import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from 'scoreboard/components/scroll-container.hbs'
import adminPanel from './admin-panel.hbs'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import unwrapModel from 'scoreboard/components/unwrap-model'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import appDisplay from 'scoreboard/components/app-display'
import groupType from 'scoreboard/admin/principals/groups/group-type'
import DependenciesPreventActionView from 'scoreboard/components/edit/dependencies-prevent-action-view'
const createjQueryErrorHandler = DependenciesPreventActionView.createjQueryErrorHandler
import spotlight from 'scoreboard/components/spotlight'
import reorderAfterDrag from 'scoreboard/components/reorder-after-drag'

var AdminPanels = Backbone.View.extend({

	// this.Model is the model constructor for
	// this.rowTemplate is the Handlebars template to use for a row

	className: 'admin table-hack display-layout admin-panels',

	labelProperty: 'label',
	thereAreNoKey: 'common.thereAreNo',

	events: {
		'click .list > li': 'clickListItem',
		'click .add': 'add',
		// need to be careful to distinguish from other edit actions for
		// scheduled imports (#24786)
		'click .edit-label': 'edit',
		'click .main-actions .edit': 'edit',
		'click .main-actions .delete': 'delete'
	},

	/**
	 * Shared functionality for admin screens that are represented as a series
	 * of panels.
	 *
	 * @property {String} [heading] can be undefined if a header should not be rendered
	 *
	 * @property {String} titleDescKeyPrefix prefix for i18n keys used to construct the title and description
	 *
	 * @property {String} [addButtonLabel='common.add'] The label for the Add button in the header
	 *
	 * @property {String} [labelProperty='label'] e.g. 'treeLabel' if the delete
	 * prompt should use a different value other than model.label
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Array} options.collection the collection of data we're working
	 * with on this screen
	 *
	 */
	initialize: function(options = {}) {
		this.options = options
		this.collection = options.collection || []
		this.urlRoot = _.result(this.Model.prototype, 'urlRoot')
		this.draggableLists = []
	},

	render: function() {
		this.covertButtonTooltips && this.covertButtonTooltips.cleanup()

		// If a heading is not provided heading won't be rendered
		// A header is not required for panels in a dialog (e.g. dataset trees)
		// (The header is only displayed in mobile layout)
		if (this.heading) {
			this.displayHeader = new DisplayHeader({
				heading: i18n.get(this.heading),
				mobileGearHidden: true
			}).render().el
		}

		this.$el.empty().append(this.displayHeader || '', template())

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	getTitleKey: function(type = '') {
		return this.titleDescKeyPrefix + type
	},

	renderEmptyPanel: function(type = '') {
		let titleKey = this.getTitleKey(type)
		const context = {
			titleKey,
			type,
			addLabel: i18n.get(this.addButtonLabel || 'common.add')
		}
		let panel = $(adminPanel(context))
			.data('type', type)

		let existingElm = this.$('.scroll-container')
			.find(`[data-type='${type}']`)

		if (existingElm.length) {
			existingElm.replaceWith(panel)
		} else {
			panel.appendTo(this.$('.scroll-container'))
		}

		return panel
	},

	renderPanel: function(type, filterCallback = () => true) {
		var panel = this.renderEmptyPanel(type)
		var list = panel.find('ul.list')

		var items = _.filter(this.collection, item =>
			_.isNil(type) || item.type === type)

		items = _.filter(items, it => filterCallback(it))

		var html = _.reduce(items, (result, currItem) => result + this.renderItem(currItem, type), '')
		list.append(html)
		if (_.isEmpty(items)) {
			this.displayEmptyStateMessage(panel, type)
		}

		return panel
	},

	/**
	 * Displays the "There are no ... " empty state message in the
	 * specified panel
	 * @param panel
	 * @param type
	 */
	displayEmptyStateMessage: function(panel, type) {
		let thereAreNoKey = this._getEmptyMessage
			? this._getEmptyMessage(type) : this.thereAreNoKey
		let message = i18n.get(thereAreNoKey, this.getTitleKey(type))
		panel.data('type', type)
			.find('.panel-content').empty()
			.attr('data-empty-state-message', message)
	},

	renderItem(item, type) {
		customIcons = {
			'google-sheets': 'docs-spreadsheet-mono',
			'zapier': 'webservice'
		}
		item.icon = customIcons[item.type] ? customIcons[item.type] : item.type

		let context = _.extend({ type }, this.rowContext(item))
		return this.rowTemplate(context)
	},

	rerenderItem: function(item) {
		let oldElm = this.getItemElm(item)
		let newElm = this.renderItem(item, oldElm.data('type'))
		oldElm.replaceWith(newElm)
	},

	rowContext: function(item) {
		return item
	},

	_itemId: function(e) {
		return this.$(e.target).closest('[data-id]').data('id')
	},

	// returns an item based on its id or event
	_item: function(id) {
		if (id.target) {
			id = this._itemId(id)
		}
		return _.find(this.collection, item => item.id == id)
	},

	clickListItem: function(e) {
		let currentTarget = this.$(e.currentTarget)
		let target = this.$(e.target)
		let isRestrictedClickArea =
			target.parents('.additional-info').length ||
			target.hasClass('additional-info')
		if (!target.hasClass('expand-collapse') && target.hasClass('button') ||
			target.hasClass('text-link') || isRestrictedClickArea) {
			// don't toggle the row if one of the non-expand/collapse buttons was clicked,
			// or if a text-link was clicked
			return
		}

		this.toggleItemElementExpanded(currentTarget)
	},

	toggleListItem: function(item) {
		// select the item that was just added or edited
		this.toggleItemElementExpanded(this.getItemElm(item))

		// toggleItemElementExpanded() may replace the item's element el with a
		// new one, so find the element again to make sure we have one that's
		// actually in the DOM
		let el = this.getItemElm(item)
		if (el.length > 0) {
			el[0].scrollIntoView()
			spotlight(el)
		}
	},

	toggleItemElementExpanded: function(el) {
		this.$('.list > li').not(el).removeClass('is-selected')
		el.toggleClass('is-selected')
	},

	getItemElm: function(item) {
		let type = item.type || _.get(item.attributes, 'type')
		const typeSelector = _.isNil(type) ? '' : `[data-type=${type}]`
		return this.$(`${typeSelector} [data-id=${item.id}]`)
	},

	// callback after an item has been added
	_onAdd: function(item) {
		this._removeItem(item.id) // prevent duplicates
		this.collection.push(item.attributes || item)
		this.render()
		this.toggleListItem(item)
		this.triggerChange()
	},

	// callback after an item has been edited
	_onEdit: function(item) {
		item = unwrapModel(item)
		for (var i=0; i<this.collection.length; i++) {
			if (this.collection[i].id == item.id) {
				this.collection[i] = item
				break
			}
		}
		this.rerenderItem(item)
		this.toggleListItem(item)
		this.triggerChange()
	},

	_removeItem: function(id) {
		_.remove(this.collection, item => item.id == id)
	},

	getOwnerHtml: function(owners) {
		return _(owners)
			.sortBy(owner => owner.label.toLowerCase())
			.map(owner => {
				let html = _.escape(owner.label)
				let groupTypeLabel = groupType.label(owner.groupType)
				if (owner.type == 'group' && groupTypeLabel) {
					html += `<span class="group-type"> (${_.escape(groupTypeLabel)})</span>`
				}
				return html
			})
			.join(', ')
	},

	/**
	 * The subclass is responsible for setting up an event handler for each
	 * DraggableList, but this function can be used for generic behavior.
	 */
	reorder: function (node, newIndex, prevIndex) {
		const id = $(node).data('id')
		const url = `${this.urlRoot}/${id}/move?index=${newIndex}`
		$.post(url, () =>
			reorderAfterDrag(this.collection, newIndex, prevIndex))
	},

	delete: function(e) {
		var id = this._itemId(e)
		var item = this._item(id)

		let itemIndex = _.indexOf(this.collection, item)
		let sibling
		if (this.collection.length > 1) {
			if (itemIndex == 0) {
				sibling = this.collection[1]
			} else {
				sibling = this.collection[itemIndex - 1]
			}
		}

		var data = _.pick(item, 'id', this.labelProperty)
		data.label = data[this.labelProperty]
		var confirmation = new DeleteConfirmation(data)
		appDisplay.dialog(confirmation)
		confirmation.once('confirm', () => {
			var url = `${this.urlRoot}/${id}`
			$.ajax({
				url,
				type: 'DELETE',
				success: () => {
					this._removeItem(id)
					this.render()

					if (sibling) {
						// #47382 the list gets re-rendered after deletion, so
						// scroll one of the deleted element's siblings into view
						let el = this.getItemElm(sibling)
						if (el.length > 0) {
							el[0].scrollIntoView()
						}
					}

					confirmation.trigger('done')
					this.trigger('delete', item)
					this.triggerChange()
				},
				error: createjQueryErrorHandler({ model: item })
			})
		})
	},

	/**
	 * Whenever an item in this.collection is added/changed/deleted
	 */
	triggerChange() {
		this.trigger('change', this.collection)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.draggableLists, 'remove')
		_.invokeMap([this.displayHeader, this.covertButtonTooltips], 'remove')
	}

})

export default AdminPanels

AdminPanels.__filename__ = 'admin/admin-panels.js'
